<!--#region Login Modal-->
<ng-container *ngIf="loginState != 0; else elseTemplate">
  <div class="row">
    <div class="col-4"></div>
    <div
      id="informationCard"
      class="mb-4 card col-4 animate__animated animate__backInDown p-3"
    >
      <ng-container *ngIf="loginState == -2; else elseTemplate">
        <div class="row">
          <div class="col-12 mb-2">
            <p>{{ "salamatLoginDescription" | translate }}</p>
          </div>
          <div class="col-12 mb-2">
            <label for="Username" class="form-label m-0"
              >{{ "Username" | translate }}:</label
            >
            <div class="validation-alert-sale-buy">
              <!-- <p>{{ backendJson.UsernameMessage }}</p> -->
            </div>
            <input
              id="Username"
              type="text"
              autocomplete="off"
              class="form-control Focusable"
              appSelectOnFocus
              [(ngModel)]="loginModel.userName"
              placeholder="{{ 'Username' | translate }}"
            />
            <!-- [ngClass]="{
                  'is-invalid':
                  backendJson.factorIdMessage != '' &&
                  backendJson.factorIdMessage != null
                  }"
                  [ngModelOptions]="{ standalone: true }"
                -->
          </div>
          <div class="col-12 mb-2">
            <label for="Password" class="form-label m-0"
              >{{ "Password" | translate }}:</label
            >
            <div class="validation-alert-sale-buy">
              <!-- <p>{{ backendJson.PasswordMessage }}</p> -->
            </div>
            <input
              id="Password"
              type="password"
              autocomplete="off"
              class="form-control Focusable"
              appSelectOnFocus
              [(ngModel)]="loginModel.password"
              placeholder="{{ 'Password' | translate }}"
            />
            <!-- [ngClass]="{
                  'is-invalid':
                  backendJson.factorIdMessage != '' &&
                  backendJson.factorIdMessage != null
                  }"
                  [ngModelOptions]="{ standalone: true }"
                -->
          </div>
          <div class="col-12 mb-2">
            <div class="d-flex justify-content-around">
              <button
                type="button"
                class="btn btn-outline-primary"
                (click)="loginFirstStep()"
              >
                {{ "LoginButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #elseTemplate>
        <div class="row">
          <div class="col-12 mb-2">
            <p>{{ "OTPDescription" | translate }}</p>
          </div>
          <div class="col-12 mb-2">
            <label for="OTP" class="form-label m-0"
              >{{ "OTP" | translate }}:</label
            >
            <div class="validation-alert-sale-buy"></div>
            <input
              id="OTP"
              type="text"
              autocomplete="off"
              class="form-control Focusable"
              appSelectOnFocus
              placeholder="{{ 'OTP' | translate }}"
              [(ngModel)]="loginModel.OTP"
            />
          </div>
          <div class="col-12 mb-2">
            <div class="d-flex justify-content-around">
              <button
                type="button"
                class="btn btn-outline-primary"
                (click)="loginSecondStep()"
              >
                {{ "LoginButton" | translate }}
              </button>
              <!-- <button
                type="button"
                class="btn btn-light"
                (click)="skipSecondStep()"
              >
                {{ "leave" | translate }}
              </button> -->
            </div>
          </div>
        </div>
      </ng-template>
      <app-loading-panel *ngIf="loading"></app-loading-panel>
    </div>
    <div class="col-4"></div>
  </div>
</ng-container>
<!--#endregion -->

<ng-template #elseTemplate>
  <div
    id="informationCard"
    class="mb-4 card animate__animated animate__backInDown"
  >
    <div class="card-body row p-3 pt-0">
      <app-loading-panel *ngIf="loading"></app-loading-panel>

      <!--#region Top Title  -->
      <div class="d-flex justify-content-start align-items-start p-1 col-6">
        <div class="input-group input-daterange" id="bs-datepicker-daterange">
          <button
            class="input-group-text"
            [ngClass]="isElectronic ? 'is-electronic' : 'not-electronic'"
            (click)="changePrescriptionStatus()"
            placement="bottom"
            ngbTooltip="{{
              isElectronic
                ? ('ElectronicPrescription' | translate)
                : ('PaperPrescription' | translate)
            }}"
          >
            <i class="far fa-address-card" *ngIf="!isElectronic"></i>
            <i class="fas fa-address-card" *ngIf="isElectronic"></i>
          </button>
          <input
            id="patientNationalCodeMessage"
            type="text"
            autocomplete="off"
            placeholder="{{ 'PatientNationalCode' | translate }}"
            [(ngModel)]="referralRequest.patientNationalCode"
            appSelectOnFocus
            appConvertNumbers
            (keyup.Enter)="getPrescription()"
            [ngClass]="{
              'is-invalid':
                referralRequest.patientNationalCodeMessage != undefined
            }"
            class="form-control Focusable iner-Focusable"
          />

          <input
            id="TrackingCode"
            *ngIf="isElectronic"
            type="text"
            placeholder="{{ 'TrackingCode' | translate }}"
            autocomplete="off"
            appSelectOnFocus
            [(ngModel)]="referralRequest.trackingCode"
            appConvertNumbers
            (keyup.Enter)="getPrescription()"
            [ngClass]="{
              'is-invalid': referralRequest.trackingCodeMessage != undefined
            }"
            class="form-control Focusable iner-Focusable"
          />
          <button
            class="input-group-text btn-info"
            (click)="getPrescription()"
            placement="bottom"
            ngbTooltip="{{ 'search' | translate }}"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-start p-1 col-6">
        <button
          type="button"
          class="btn btn-icon btn-outline-primary ms-1"
          placement="bottom"
          [routerLink]="['/Sale']"
          ngbTooltip="{{ 'Prescription' | translate }}"
        >
          <span class="fas fa-prescription-bottle-alt"></span>
        </button>
        <button
          type="button"
          class="btn btn-icon btn-outline-primary ms-1"
          placement="bottom"
          [routerLink]="['/SaleList']"
          ngbTooltip="{{ 'List' | translate }}"
        >
          <span class="tf-icons bx bx-list-check"></span>
        </button>
      </div>
      <!--#endregion -->

      <!--#region Patient information -->
      <div class="col-6 p-2">
        <div id="patient-information" class="elec-box row pb-3 elec-box mx-1">
          <div
            class="top-input-box d-flex align-items-center col-5 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "patientFirstName" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.patientFirstName ?? "-" | dataType : "" }}
            </p>
          </div>
          <div
            class="top-input-box d-flex align-items-center col-5 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "patientLastName" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.patientLastName ?? "-" | dataType : "" }}
            </p>
          </div>

          <div
            class="top-input-box d-flex align-items-center col-2 justify-content-start"
          >
            <label class="form-label pt-2"> {{ "Gender" | translate }}: </label>
            <p class="m-0 ms-3">
              {{ this.referral.patientGender ?? "-" }}
            </p>
          </div>

          <div
            class="top-input-box d-flex align-items-center col-5 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "TypeOfInsurance" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.patientInsuranceType ?? "-" | dataType : "" }}
            </p>
          </div>
          <div
            class="top-input-box d-flex align-items-center col-7 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "PatientBirthDay" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.patientBirthDate ?? "-" | dataType : "" }}
            </p>
          </div>
        </div>
      </div>
      <!--#endregion -->

      <!--#region doctor information -->
      <div class="col-6 p-2">
        <div id="patient-information" class="elec-box row pb-3 elec-box mx-1">
          <div
            class="top-input-box d-flex align-items-center col-5 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "doctorName" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.doctorName ?? "-" | dataType : "" }}
            </p>
          </div>
          <div
            class="top-input-box d-flex align-items-center col-3 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "DoctorCode" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.doctorId ?? "-" | dataType : "" }}
            </p>
          </div>

          <div
            class="top-input-box d-flex align-items-center col-4 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "PrescriptionDate" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.prescriptionDate | persianDate }}
            </p>
          </div>

          <div
            class="top-input-box d-flex align-items-center col-12 justify-content-start"
          >
            <label class="form-label pt-2">
              {{ "doctorSpecialty" | translate }}:
            </label>
            <p class="m-0 ms-3">
              {{ this.referral.doctorSpecialty ?? "-" | dataType : "" }}
            </p>
          </div>
        </div>
      </div>
      <!--#endregion -->

      <!--#region doctor Prescription -->
      <ng-container *ngIf="isElectronic">
        <div class="col-12 p-2">
          <div id="doctor-prescription" class="elec-box row elec-box mx-1 p-2">
            <div class="box-title">
              {{ "DoctorPrescription" | translate }}
            </div>
            <table class="table table-bordered table-striped mt-4">
              <thead>
                <tr>
                  <th>
                    {{ "PrescriptionDrug" | translate }}
                  </th>
                  <th>
                    {{ "BrandIsImportant" | translate }}
                  </th>
                  <th>
                    {{ "RequestCount" | translate }}
                  </th>
                  <th>
                    {{ "numberOfPeriod" | translate }}
                  </th>
                  <th>
                    {{ "usetypeid" | translate }}
                  </th>
                  <th>
                    {{ " " | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="
                    let item of this.referral.prescription.drugs;
                    let j = index
                  "
                >
                  <tr
                    (click)="rowClick(item)"
                    [ngClass]="
                      item.subscriptionDeliveredInfos == null ||
                      item.subscriptionDeliveredInfos.length == 0
                        ? ''
                        : 'fired'
                    "
                    class="selective"
                  >
                    <td>
                      <p class="m-0 px-1">
                        {{ item.brandName }}
                      </p>
                      <p
                        class="m-0 ms-4"
                        *ngFor="let innerItem of item.bulkDrugInfos"
                      >
                        {{ innerItem.name }} - {{ innerItem.count }}
                      </p>
                    </td>
                    <td>
                      <i
                        *ngIf="item.writeWithBrand"
                        class="far fa-check-circle"
                      ></i>
                      <i
                        *ngIf="!item.writeWithBrand"
                        class="far fa-times-circle"
                      ></i>
                    </td>
                    <td>
                      {{ item.requestCount }}
                    </td>
                    <td>
                      {{ item.persianConsumption }}
                    </td>
                    <td>
                      {{ item.numberOfPeriod | dataType : "" }}
                    </td>

                    <td>
                      <button
                        type="button"
                        placement="right"
                        ngbTooltip="{{ 'Select' | translate }}"
                        class="btn btn-icon btn-outline-success mt-1 me-1"
                      >
                        <i class="fas fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
      <!--#endregion -->

      <!--#region factor Prescription -->
      <div class="col-12 p-2">
        <div class="elec-box row p-2 elec-box mx-1">
          <div
            class="position-absolute top-0 start-0 d-flex justify-content-end align-items-center"
          >
            <button
              type="button"
              class="btn btn-icon btn-outline-primary mt-1 me-1"
              *ngIf="!isElectronic"
              ngbTooltip="{{ 'AddBulk' | translate }}"
              (click)="openBulkModal()"
            >
              <i class="fas fa-vial"></i>
            </button>
            <button
              type="button"
              class="btn btn-icon btn-outline-primary mt-1"
              ngbTooltip="{{ 'Add' | translate }}"
              (click)="addNewDrug()"
            >
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <div class="box-title">
            {{ "SaleFactor" | translate }}
          </div>
          <table class="table table-bordered table-striped mt-4">
            <thead>
              <tr>
                <th>
                  {{ "brandName" | translate }}
                </th>
                <th>
                  {{ "count" | translate }}
                </th>
                <th>
                  {{ "basePrice" | translate }}
                </th>
                <th>
                  {{ "OrganizationPrice" | translate }}
                </th>
                <th>
                  {{ "InsurancePrice" | translate }}
                </th>
                <th>
                  {{ "PatientShare" | translate }}
                </th>
                <th>
                  {{ "Sum" | translate }}
                </th>
                <th>
                  {{ " " | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="
                  let item of this.referral.prescription.selectDrug;
                  let j = index
                "
              >
                <ng-container *ngIf="item.bulkId > 0; else elseTemplate">
                  <tr>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        {{ bulk.brandName }}
                      </p>
                      <p class="m-0 px-1 border-top">
                        {{ item.brandName }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        {{ bulk.requestCount }}
                      </p>
                      <p class="border-top">
                        {{ item.requestCount }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        + {{ bulk.basePrice | dataType : "price" }}
                      </p>
                      <p class="border-top">
                        {{ item.basePrice | dataType : "price" }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        +
                        {{ bulk.prefExchangePart | dataType : "price" }}
                      </p>
                      <p class="border-top">
                        {{ item.prefExchangePart | dataType : "price" }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        + {{ bulk.orgAmount | dataType : "price" }}
                      </p>
                      <p class="border-top">
                        {{ item.orgAmount | dataType : "price" }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        + {{ bulk.paidPrice | dataType : "price" }}
                      </p>
                      <p class="border-top">
                        {{ item.paidPrice | dataType : "price" }}
                      </p>
                    </td>
                    <td>
                      <p
                        class="m-0 px-1"
                        *ngFor="let bulk of item.bulkDrugInfos"
                      >
                        + {{ bulk.totalPrice | dataType : "price" }}
                      </p>
                      <p class="border-top">
                        {{ item.totalPrice | dataType : "price" }}
                      </p>
                    </td>

                    <td>
                      <button
                        type="button"
                        class="btn btn-icon btn-outline-danger"
                        placement="bottom"
                        ngbTooltip="{{ 'Remove' | translate }}"
                        (click)="deSelectItem(item)"
                      >
                        <i class="bx bx-x"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-icon btn-outline-primary"
                        placement="bottom"
                        ngbTooltip="{{ 'BarcodeList' | translate }}"
                        *ngIf="item.Esalat"
                        (click)="selectToUploadBarcode(j)"
                      >
                        <i class="fa-solid fa-qrcode"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #elseTemplate>
                  <tr>
                    <td>
                      <p class="m-0 px-1">
                        {{ item.brandName }}
                      </p>
                    </td>
                    <td>
                      {{ item.requestCount }}
                    </td>
                    <td>
                      {{ item.basePrice | dataType : "price" }}
                    </td>
                    <td>
                      {{ item.prefExchangePart | dataType : "price" }}
                    </td>
                    <td>
                      {{ item.orgAmount | dataType : "price" }}
                    </td>
                    <td>
                      {{ item.paidPrice | dataType : "price" }}
                    </td>
                    <td>
                      {{ item.totalPrice | dataType : "price" }}
                    </td>

                    <td>
                      <button
                        type="button"
                        class="btn btn-icon btn-outline-danger"
                        placement="bottom"
                        ngbTooltip="{{ 'Remove' | translate }}"
                        (click)="deSelectItem(item)"
                      >
                        <i class="bx bx-x"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-icon btn-outline-primary"
                        placement="bottom"
                        ngbTooltip="{{ 'BarcodeList' | translate }}"
                        *ngIf="item.Esalat"
                        (click)="selectToUploadBarcode(j)"
                      >
                        <i class="fa-solid fa-qrcode"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </ng-container>
            </tbody>
            <!-- <tfoot>
              <tr>
                <td colspan="3">
                  {{ "Sum" | translate }}
                </td>
                <td>{{ totalPrefExchangePart | dataType : "price" }}</td>
                <td>{{ totalOrgAmount | dataType : "price" }}</td>
                <td>{{ totalPaidPrice | dataType : "price" }}</td>
                <td>{{ totalTotalPrice | dataType : "price" }}</td>
                <td colspan="2"></td>
              </tr>
            </tfoot> -->
          </table>
          <div class="row">
            <div class="col-10"></div>
            <div class="col-2">
              <div class="row">
                <div class="col-6 p-0">
                  <p class="mb-0">{{ "Sum" | translate }} :</p>
                </div>
                <div
                  class="col-6 p-0 d-flex justify-content-end align-items-center"
                >
                  <p class="mb-0">
                    {{ totalTotalPrice | dataType : "" }}
                  </p>
                  <span class="ms-1">
                    {{ "Rial" | translate }}
                  </span>
                </div>

                <div class="col-6 p-0">
                  <p class="mb-0">{{ "OrganizationPrice" | translate }} :</p>
                </div>
                <div
                  class="col-6 p-0 d-flex justify-content-end align-items-center"
                >
                  <p class="mb-0">
                    {{ totalPrefExchangePart | dataType : "" }}
                  </p>
                  <span class="ms-1">
                    {{ "Rial" | translate }}
                  </span>
                </div>

                <div class="col-6 p-0">
                  <p class="mb-0">{{ "InsurancePrice" | translate }} :</p>
                </div>
                <div
                  class="col-6 p-0 d-flex justify-content-end align-items-center"
                >
                  <p class="mb-0">
                    {{ totalOrgAmount | dataType : "" }}
                  </p>
                  <span class="ms-1">
                    {{ "Rial" | translate }}
                  </span>
                </div>

                <div class="col-6 p-0">
                  <p class="mb-0">{{ "TechnicalRight" | translate }} :</p>
                </div>
                <div
                  class="col-6 p-0 d-flex justify-content-end align-items-center"
                >
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control Focusable iner-Focusable search-input-box p-0"
                    placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                    [(ngModel)]="technicalRight"
                    mask="separator.0"
                    style="direction: ltr"
                    appSelectOnFocus
                    thousandSeparator=","
                  />

                  <!-- <p class="mb-0">
                    {{ totalTotalPrice | dataType : "" }}
                  </p>
                  -->
                  <span class="ms-1">
                    {{ "Rial" | translate }}
                  </span>
                </div>

                <div class="col-6 p-0">
                  <p class="mb-0">{{ "PaidPrice" | translate }} :</p>
                </div>
                <div
                  class="col-6 p-0 d-flex justify-content-end align-items-center"
                >
                  <p class="mb-0">
                    {{ paidPrice | dataType : "" }}
                  </p>
                  <span class="ms-1">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion -->

      <div class="col-12">
        <div class="mt-4 d-flex justify-content-center align-items-center">
          <button
            type="button"
            *ngIf="!isElectronic"
            class="btn btn-primary me-2"
            (click)="GetTrackingCodePaper()"
          >
            {{ "GetTrackingCode" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary me-2"
            (click)="DeliveringPrescription()"
          >
            {{ "Submit" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-label-secondary"
            (click)="clearPage()"
          >
            {{ "Clear" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--#region Message Modal -->
<ng-template #itemEdit let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <ng-container *ngIf="showAddBox; else elseTemplate">
      <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
        {{ "AddDrugToPrescription" | translate }}
      </h6>
    </ng-container>
    <ng-template #elseTemplate>
      <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
        {{ "Equivalence" | translate }}
      </h6>
    </ng-template>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <ng-container *ngIf="editItem != null">
        <div class="col-12 p-0 mt-2">
          <div class="add-box-item elec-box h-auto p-2 ms-1">
            <div class="row px-2">
              <div class="col-10 mb-3">
                <div
                  class="edit-form"
                  appClickOutside
                  (clickOutside)="modalIsOpen = false"
                >
                  <label class="form-label">
                    {{ "DrugOnSalamat" | translate }}
                  </label>
                  <ng-container *ngIf="showAddBox; else elseTemplate">
                    <div
                      class="input-group input-box-search-advance row ms-1 p-0 w-100"
                    >
                      <input
                        id="drugBrandName"
                        type="text"
                        autocomplete="off"
                        appSelectOnFocus
                        class="form-control Focusable iner-Focusable search-input-box"
                        placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                        [(ngModel)]="editItem.brandName"
                        (keyup.escape)="modalIsOpen = false"
                        (keyup.Enter)="searchDrug()"
                      />
                    </div>
                    <app-search-box
                      [data]="searchSalamatData"
                      [addButton]="false"
                      [right]="'-49%'"
                      [fields]="searchFields"
                      [modalIsOpen]="bulkModalIsOpen"
                      (parentAction)="parentSearchAction($event)"
                    ></app-search-box>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <ng-container
                      *ngIf="
                        this.editableListItem.length == 0;
                        else elseTemplate
                      "
                    >
                      <input
                        id="requestCount"
                        type="text"
                        autocomplete="off"
                        [(ngModel)]="editItem.brandName"
                        disabled
                        appSelectOnFocus
                        class="form-control Focusable iner-Focusable"
                      />
                    </ng-container>
                    <ng-template #elseTemplate>
                      <div class="validation-alert-sale-buy">
                        <p>
                          {{
                            editItemValidation.serviceNationalNumber ?? ""
                              | translate
                          }}
                        </p>
                      </div>
                      <app-drop-down
                        [dropDownData]="editableListItem"
                        [isValid]="
                          editItemValidation.serviceNationalNumber == null
                        "
                        (ngModelValueChange)="onDropDownChange($event)"
                      >
                      </app-drop-down>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
              <div class="col-2 mb-3">
                <div class="edit-form row drugcount-status px-2">
                  <div class="validation-alert-count-sale-buy"></div>

                  <label class="form-label" for="requestCount">
                    {{ "requestCount" | translate }}
                  </label>
                  <input
                    id="requestCount"
                    type="text"
                    autocomplete="off"
                    [(ngModel)]="editItem.requestCount"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    mask="separator.0"
                    (keyup)="validateSaveEditChange()"
                    thousandSeparator=","
                    [ngClass]="{
                      'is-invalid': editItemValidation.requestCount != null
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 mt-2">
          <div class="add-box-item elec-box h-auto p-2 me-1">
            <div class="row px-2">
              <div class="col-10 mb-3">
                <div
                  class="edit-form"
                  appClickOutside
                  (clickOutside)="modalIsOpen = false"
                >
                  <label class="form-label" for="DrugOnStock">
                    {{ "DrugOnStock" | translate }}
                  </label>
                  <div class="validation-alert-sale-buy">
                    <p>
                      {{ editItemValidation.stock.brandName ?? "" | translate }}
                    </p>
                  </div>
                  <div class="input-group input-daterange">
                    <input
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control Focusable iner-Focusable"
                      placeholder="{{ 'genericCode' | translate }}"
                      (keyup.escape)="modalIsOpen = false"
                      [(ngModel)]="editItem.stock.genericCode"
                      (keyup.Enter)="searchDrugByGeneric()"
                      (keyup)="validateSaveEditChange()"
                      [ngClass]="{
                        'is-invalid': editItemValidation.stock.brandName != null
                      }"
                    />
                    <input
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control Focusable iner-Focusable w-50"
                      placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                      (keyup.escape)="modalIsOpen = false"
                      [(ngModel)]="editItem.stock.brandName"
                      (keyup)="validateSaveEditChange()"
                      (keyup.Enter)="searchWithName()"
                      [ngClass]="{
                        'is-invalid': editItemValidation.stock.brandName != null
                      }"
                    />
                    <button
                      class="input-group-text"
                      type="button"
                      ngbTooltip="{{ 'ScanBarcode' | translate }}"
                    >
                      <!-- (click)="openCamera()" -->
                      <i class="bx bx-barcode-reader"></i>
                    </button>
                  </div>
                  <app-search-box
                    [data]="searchData"
                    [right]="'-49%'"
                    [addButton]="false"
                    [fields]="searchStockFields"
                    [urlName]="'columnsArray_saleSalamatSearch'"
                    [paging]="searchPaging"
                    [modalIsOpen]="modalIsOpen"
                    (parentAction)="parentSearchStockAction($event)"
                  ></app-search-box>
                </div>
              </div>
              <div class="col-2 mb-3">
                <div class="edit-form row drugcount-status px-2">
                  <div class="validation-alert-count-sale-buy"></div>

                  <label class="form-label" for="saleCount">
                    {{ "saleCount" | translate }}
                  </label>
                  <input
                    id="saleCount"
                    type="text"
                    autocomplete="off"
                    [(ngModel)]="editItem.stock.saleCount"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    mask="separator.0"
                    (keyup)="validateSaveEditChange()"
                    thousandSeparator=","
                    [ngClass]="{
                      'is-invalid': editItemValidation.stock.saleCount != null
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="edit-form row drugcount-status px-2">
            <div class="validation-alert-count-sale-buy"></div>

            <label class="form-label" for="UsageTime">
              {{ "UsageTime" | translate }}
            </label>
            <div class="validation-alert-sale-buy">
              <p>
                {{ editItemValidation.consumption ?? "" | translate }}
              </p>
            </div>
            <app-drop-down
              [defaultValue]="editItem.consumption"
              [dropDownData]="salamatData"
              [isValid]="editItemValidation.consumption == null"
              (ngModelValueChange)="editItem.consumption = $event.id"
            >
            </app-drop-down>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="edit-form row drugcount-status px-2">
            <div class="validation-alert-count-sale-buy"></div>

            <label class="form-label" for="numberOfPeriod">
              {{ "numberOfPeriod" | translate }}
            </label>
            <div class="validation-alert-sale-buy">
              <p>
                {{ editItemValidation.numberOfPeriod ?? "" | translate }}
              </p>
            </div>
            <app-drop-down
              [defaultValue]="editItem.numberOfPeriod?.toString()"
              [dropDownData]="salamatNumberOfPeriod"
              [isValid]="editItemValidation.numberOfPeriod == null"
              (ngModelValueChange)="editItem.numberOfPeriod = $event.id"
            >
            </app-drop-down>
          </div>
        </div>
        <div class="col-12">
          <div class="edit-form row drugcount-status px-2">
            <div class="validation-alert-count-sale-buy"></div>

            <label class="form-label" for="DoctorDescription">
              {{ "DoctorDescription" | translate }}
            </label>
            <textarea
              id="Number"
              class="form-control focusable inner-focusable"
              [(ngModel)]="editItem.description"
            ></textarea>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-primary"
      id="save-button"
      (click)="saveEditChange()"
    >
      <i class="far fa-save"></i>
      {{ "Save" | translate }}
    </button>
    <button
      type="button"
      id="clear-button"
      class="btn btn-light ms-2"
      (click)="closeEditChange()"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</ng-template>
<!--#endregion -->

<!--#region Print Modal-->
<app-sale-print-factor
  [modalIsOpen]="receptModalIsOpen"
  [recept]="recept"
  (parentAction)="printParentAction($event)"
></app-sale-print-factor>
<!--#endregion -->

<!--#region Scan Barcode Modal-->
<ng-template
  #ScanBarcodeModal
  let-modal
  class="modal modal-top fade"
  *ngIf="uploadBarcodeItem != null"
>
  <app-scan-barcode-modal-salamat
    [barcodeList]="uploadBarcodeItem.barcode"
    [UIDViewModel]="uidViewModel"
    [drugName]="uploadBarcodeItem.brandName"
    [drugId]="uploadBarcodeItem.id"
    (parentActionOutput)="parentBarcodeAction($event)"
  ></app-scan-barcode-modal-salamat>
</ng-template>
<!--#endregion -->

<!--#region Success Modal-->
<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentSearchAction($event)"
>
</app-pcsuccess-modal>
<!--#endregion -->

<!--#region pcconfrim Modal-->
<app-pcconfrim-modal
  *ngIf="modalConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>
<!--#endregion -->

<!--#region bulkItem Modal-->
<ng-template #bulkItem let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "MessageList" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="col-12">
        <div
          id="add-new-box"
          class="row p-2 mx-1 mb-3 mt-2 add-box-item elec-box"
        >
          <table class="table">
            <thead>
              <tr>
                <th>
                  {{ "brandName" | translate }}
                </th>
                <th>
                  {{ "count" | translate }}
                </th>
                <th>
                  {{ "basePrice" | translate }}
                </th>
                <th>
                  {{ "OrganizationPrice" | translate }}
                </th>
                <th>
                  {{ "InsurancePrice" | translate }}
                </th>
                <th>
                  {{ "PatientShare" | translate }}
                </th>
                <th>
                  {{ "Sum" | translate }}
                </th>
                <th>
                  {{ " " | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let item of bulkParentPaper.bulkDrugInfos;
                  let j = index
                "
              >
                <td>
                  <p class="m-0 px-1">
                    {{ item.brandName }}
                  </p>
                </td>
                <td>
                  {{ item.requestCount }}
                </td>
                <td>
                  {{ item.basePrice | dataType : "price" }}
                </td>
                <td>
                  {{ item.prefExchangePart | dataType : "price" }}
                </td>
                <td>
                  {{ item.orgAmount | dataType : "price" }}
                </td>
                <td>
                  {{ item.paidPrice | dataType : "price" }}
                </td>
                <td>
                  {{ item.totalPrice | dataType : "price" }}
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-icon btn-outline-danger"
                    placement="bottom"
                    ngbTooltip="{{ 'Remove' | translate }}"
                    (click)="deSelectBulkItem(item)"
                  >
                    <i class="bx bx-x"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="col-10 mb-3">
            <div
              class="edit-form search-input-box"
              appClickOutside
              (clickOutside)="modalIsOpen = false"
            >
              <div class="validation-alert-sale-buy"></div>
              <label class="form-label" for="drugBrandName">
                {{ "ProductBrandName" | translate }}
              </label>

              <div
                class="input-group input-box-search-advance row ms-1 p-0 w-100"
              >
                <input
                  id="drugBrandName"
                  type="text"
                  autocomplete="off"
                  appSelectOnFocus
                  class="form-control Focusable iner-Focusable search-input-box"
                  placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                  [(ngModel)]="newBulkParentPaper.brandName"
                  (keyup.enter)="searchBulkDrug()"
                  (keyup.escape)="modalIsOpen = false"
                />
              </div>
              <app-search-box
                [data]="searchSalamatData"
                [addButton]="false"
                [fields]="searchFields"
                [modalIsOpen]="bulkModalIsOpen"
                (parentAction)="parentBulkSearchAction($event)"
              ></app-search-box>
            </div>
          </div>
          <div class="col-2 mb-3">
            <div class="form-check form-switch mb-2">
              <label class="form-check-label" for="flexSwitchCheckChecked">
                {{ "SearchWithIRC" | translate }}
              </label>
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckChecked"
                [checked]="searchWithIRC"
                [(ngModel)]="searchWithIRC"
              />
            </div>
          </div>
          <div class="col-2 mb-3">
            <div class="edit-form row drugcount-status px-2">
              <div class="validation-alert-count-sale-buy"></div>

              <label class="form-label" for="Number">
                {{ "Number" | translate }}
              </label>
              <input
                id="Number"
                type="text"
                autocomplete="off"
                [(ngModel)]="newBulkParentPaper.requestCount"
                appSelectOnFocus
                class="form-control Focusable iner-Focusable"
              />
            </div>
          </div>

          <div class="col-10 mb-3">
            <div class="edit-form row drugcount-status px-2">
              <div class="validation-alert-count-sale-buy"></div>

              <label class="form-label" for="DoctorDescription">
                {{ "DoctorDescription" | translate }}
              </label>
              <textarea
                id="Number"
                class="form-control focusable inner-focusable"
                [(ngModel)]="newBulkParentPaper.description"
              ></textarea>
            </div>
          </div>
          <div class="col-12">
            <hr />
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary"
              id="save-button"
              (click)="saveAddDrugBulk()"
            >
              <i class="far fa-save"></i>
              {{ "Save" | translate }}
            </button>

            <button
              type="button"
              id="clear-button"
              class="btn btn-light ms-2"
              (click)="closeAdd()"
            >
              <i class="bx bx-x"></i>
              {{ "Close" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-outline-success"
      (click)="importBulkToPresc()"
    >
      <i class="bx bx-x"></i>
      {{ "AddToPrescription" | translate }}
    </button>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</ng-template>
<!--#endregion -->
